import axios from 'axios'

export const ProtegesService = {
    loadProteges: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/proteges')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    deleteProtege: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/proteges/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    loadProtege: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/proteges/' + id + '/info')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/proteges-service.js